module.exports = __webpack_public_path__ + "static/media/zoom.91447ac6.svg";